export default __webpack_public_path__ + "static/media/upload-icon.0652ac6a.svg";